import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './DropDownList.sass';

class DropDownList extends Component {
  constructor(props) {
    super(props);
    this.state = { opened: false };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleToggleMenu = this.handleToggleMenu.bind(this);
  }

  handleSelect(option) {
    return () => {
      this.props.onSelect(option);
      this.setState({ opened: false });
    };
  }

  handleToggleMenu() {
    this.setState({ opened: !this.state.opened });
  }

  render() {
    const {
      title,
      options,
      selected,
      width
    } = this.props;

    const { opened } = this.state;

    return (
      <div className="DropDownList">
        <p className="title">{title}</p>
        <button
          className={`input-field ${opened && 'active'}`}
          style={{ width: `${width}pt` }}
          onClick={this.handleToggleMenu}
        >
          {selected.title}
        </button>

        <ul
          className="options"
          style={{
            width: `${width}pt`,
            display: opened ? 'block' : 'none'
          }}
        >
          {
            options.map(option => (
              <li
                key={option.title}
                className={`${options.value === selected.value ? 'active' : ''}`}
              >
                <button onClick={this.handleSelect(option)}>
                  {option.title}
                </button>
              </li>
            ))
          }
        </ul>
      </div>
    );
  }
}

DropDownList.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired
  })).isRequired,
  selected: PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired
  }).isRequired,
  width: PropTypes.number,
  onSelect: PropTypes.func
};

DropDownList.defaultProps = { width: 150, onSelect() {} };
export default DropDownList;



// WEBPACK FOOTER //
// ./src/components/DropDownList.jsx